import { _USER_ACTIVE } from '@/config'
import { existsProp } from "../../services/utils";
const StateAuth = {
    user: {
        authenticated: false,
        admin: true,
        token: null,
        msgAuth: null,
        perfil:{},
        listHost:[],
        hostId:'hostIdActive-092kko',
        modulos:[],
        hPwd:"",
        infoHost:{
            hostId: "",
            creation_date: "",
            start_date: "",
            end_date: "0000-00-00 00:00:00",
            cams: 0,
            descr: "",
            user: ""
        },
        notificacao:{
            adm: "",
            watch: ["", "", "", "", "", ""]
        },
        emailRecuperacao:'',
        email:'',
        publicKey:''
    }
}
const GettersAuth = {
    isLogin: (state) => state.user.authenticated,
    isAdmin: (state) => state.user.admin,
    getPerfil: (state) => state.user.perfil,
    getToken: (state) => state.user.token,
    getPwd: (state) => state.user.hPwd,
    getLsPwd: () => localStorage.getItem('_HPWD'),//local storage
    getMsgAuth: (state) => state.user.msgAuth,
    getEmailRecuperacao: (state) => state.emailRecuperacao,
    getEmail: (state) => state.user.email,
    nomeUser: (state) => state.user.perfil.nome,
    hostActive: (state) => state.user.hostId,
    listHost: (state) => state.user.listHost,
    infoHost: (state) => state.user.infoHost,
    infoNotificacao: (state) => state.user.notificacao,
    getCodePlan: (state) =>{
        return (existsProp(state.user.infoHost,"preapproval_id")) ? state.user.infoHost.preapproval_id : false
    },
    getPublicKey: (state) => state.user.publicKey,
}
const MutationsAuth = {
    checkLogin: state => state.user.authenticated = true,
    saveToken: (state, token) => {
        // localStorage.setItem(_TOKEN_KEY, token);
        state.user.token = token
        if (token) {
            state.user.authenticated = true
        }
    },
    setPerfil: (state,payload) => {
        // localStorage.setItem('_perfil',payload)
        state.user.perfil = payload
    },
    setPwd: (state,payload) => {
        localStorage.setItem('_HPWD',payload)
        state.user.hPwd = payload
    },
    removeToken: state => {
        // localStorage.removeItem(_TOKEN_KEY)
        state.user.token = false
        state.user.authenticated = false
    },
    setMsgAuth: (state, msg) => {
        state.user.msgAuth = msg
    },
    setEmailRecuperacao: (state, email) => {
        state.emailRecuperacao = email
    },
    setEmail: (state, email) => {
        localStorage.setItem(_USER_ACTIVE, email)
        state.user.email = email
    },
    setPromo: (state, payload) => {
        state.user.perfil.promo = payload
    },
    setHostActive: (state, payload) => {
        state.user.hostId = payload
    },
    setListHost: (state, payload) => {
        state.user.listHost = payload
    },
    setInfoHost: (state, payload) => {
        state.user.infoHost = payload
    },
    setInfoNotificacao: (state, payload) => {
        state.user.notificacao = payload
    },
    setPublicKey: (state, payload) => {
        state.user.publicKey = payload
    },
    
    
}
const ActionsAuth = {
    setPwd: (context,payload) => {
        context.commit('setPwd', payload)
    },
    setToken: (context, token) => {
        context.commit('saveToken', token)
    },
    resetToken: context => {
        context.commit('removeToken')
    },
    setMsgAuth: (context, payload) => {
        context.commit('setMsgAuth', payload)
    },
    setPerfil: (context, payload) => {
        context.commit('setPerfil', payload)
    },
    setEmailRecuperacao: (context, payload) => {
        context.commit('setEmailRecuperacao', payload)
    },
    setEmail: (context, payload) => {
        context.commit('setEmail', payload)
    },
    setPromo: (context, payload) => {
        context.commit('setPromo', payload)
    },
    setHostActive: (context, payload) => {
        context.commit('setHostActive', payload)
    },
    setListHost: (context, payload) => {
        context.commit('setListHost', payload)
    },
    setInfoHost: (context, payload) => {
        context.commit('setInfoHost', payload)
    },
    setInfoNotificacao: (context, payload) => {
        context.commit('setInfoNotificacao', payload)
    },
    setPublicKey: (context, payload) => {
        context.commit('setPublicKey', payload)
    },
}

export { StateAuth, GettersAuth, MutationsAuth, ActionsAuth } 